import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const submitContact = async (payload) => {
  const { data } = await apiClient.post("/contact", payload);
  return data;
};

export const submitRfq = async (formData) => {
  const { data } = await apiClient.post("/rfq", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const fetchPartners = async () => {
  const { data } = await apiClient.get("/partners");
  return data;
};
